import React, { useState, useEffect } from 'react'
import { Plus } from 'react-feather'

import './Input.css'

export const Input = ({
  type,
  name,
  id,
  label,
  placeholder,
  withLabel = true,
  buttonText = '',
  required = true
}) => {
  const [mobileWidth, setMobileWidth] = useState(false)

  const updateDimensions = () => {
    setMobileWidth(window.innerWidth <= 510)
  }

  useEffect(() => {
    updateDimensions()
    window.addEventListener('resize', () => updateDimensions())
    return () => {
      window.removeEventListener('resize', updateDimensions)
    }
  }, [])

  return (
    <div className="Input--Container relative">
      {withLabel && (
        <label className="Input--Label" htmlFor={id}>
          {label} {required && <span>(required)</span>}
        </label>
      )}
      {type === 'textarea' ? (
        <textarea
          name="textarea"
          rows="5"
          id={id}
          cols="20"
          wrap="off"
          required={required}
          placeholder={placeholder}
        ></textarea>
      ) : (
        <input
          type={type}
          name={name}
          id={id}
          placeholder={placeholder}
          aria-label={label}
          className="relative"
          autoComplete="off"
          required={required}
        />
      )}
      <button
        className={`Card_Link ${!withLabel && `Input--withLabel`}`}
        type="submit"
      >
        {!withLabel &&
          (mobileWidth ? (
            <Plus size={22} />
          ) : (
            <>
              <Plus size={22} />
              <span>{buttonText}</span>
            </>
          ))}
      </button>
    </div>
  )
}

export default Input
